(() => {
  const bar = document.querySelector('[data-mix-builder-bar]');
  if (!bar) return;

  const countEl = bar.querySelector('[data-mix-count]');
  const totalEl = bar.querySelector('[data-mix-total]');
  const textEl = bar.querySelector('[data-mix-text]');
  const bottles = Array.from(bar.querySelectorAll('[data-mix-bottle]'));
  const cartBtn = bar.querySelector('[data-mix-open-cart]');
  const progress = bar.querySelector('.mix-builder__bottles');
  const target = Number(bar.dataset.target || 6);
  const percent = bar.dataset.percent || '15';
  const shippingThreshold = Number(bar.dataset.shippingThreshold || 99900);
  let currentQty = Number(bar.dataset.qty || 0);
  let currentTotal = Number(bar.dataset.cartTotal || 0);

  const publish = (eventName, payload) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...payload });
  };

  const fillCopy = (template, count) =>
    String(template || '')
      .replace(/\[\[count\]\]/g, String(count))
      .replace(/\{\{\s*count\s*\}\}/g, String(count))
      .replace(/\{\{\s*percent\s*\}\}/g, percent)
      .replace(/\{\{\s*remaining\s*\}\}/g, String(count));

  const hasFreeShipping = (total) =>
    shippingThreshold > 0 && Number(total) > 0 && Number(total) >= shippingThreshold;

  const copyForQty = (qty, total) => {
    let copy = '';
    if (qty >= target) copy = fillCopy(bar.dataset.copyAchieved, qty);
    else if (qty < 1) copy = fillCopy(bar.dataset.copyEmpty, target);
    else {
      const remaining = Math.max(target - qty, 0);
      const template =
        remaining === 1 ? bar.dataset.copyRemainingOne : bar.dataset.copyRemainingMany;
      copy = fillCopy(template, remaining);
    }
    return copy;
  };

  const render = (qty, { animate, total } = {}) => {
    const next = Math.max(0, Number(qty) || 0);
    const nextTotal = total == null ? currentTotal : Math.max(0, Number(total) || 0);
    const filled = Math.min(next, target);
    const previousFilled = Math.min(currentQty, target);

    bottles.forEach((bottle, index) => {
      const isFilled = index < filled;
      bottle.classList.toggle('is-filled', isFilled);
      if (animate && isFilled && index >= previousFilled) {
        bottle.classList.remove('is-bump');
        void bottle.offsetWidth;
        bottle.classList.add('is-bump');
        window.setTimeout(() => bottle.classList.remove('is-bump'), 280);
      }
    });

    if (countEl) countEl.textContent = `${next}/${target}`;
    if (textEl) textEl.textContent = copyForQty(next, nextTotal);
    if (progress) progress.setAttribute('aria-valuenow', String(filled));

    bar.classList.toggle('has-items', next > 0);
    bar.classList.toggle('is-achieved', next >= target);
    bar.classList.toggle('has-free-shipping', hasFreeShipping(nextTotal));
    bar.dataset.qty = String(next);
    bar.dataset.cartTotal = String(nextTotal);
    if (currentQty < target && next >= target) {
      publish('mix_builder_threshold_reached', {
        eligible_qty: next,
        target,
        percent: Number(percent),
      });
    }
    currentQty = next;
    currentTotal = nextTotal;
  };

  const readCartAmount = () => {
    const widget = document.querySelector('cart-amount');
    if (!widget) return null;
    const qty =
      widget.dataset.mixQty == null || widget.dataset.mixQty === ''
        ? null
        : Number(widget.dataset.mixQty);
    const totalCents =
      widget.dataset.cartTotal == null || widget.dataset.cartTotal === ''
        ? null
        : Number(widget.dataset.cartTotal);
    return {
      qty: qty == null || Number.isNaN(qty) ? null : qty,
      totalCents: totalCents == null || Number.isNaN(totalCents) ? null : totalCents,
      totalMoney: widget.dataset.cartTotalMoney || '',
    };
  };

  const syncFromCartAmount = (animate) => {
    const snapshot = readCartAmount();
    if (!snapshot) return;
    if (snapshot.totalMoney && totalEl && totalEl.textContent !== snapshot.totalMoney) {
      totalEl.textContent = snapshot.totalMoney;
    }
    const qty = snapshot.qty == null ? currentQty : snapshot.qty;
    const total = snapshot.totalCents == null ? currentTotal : snapshot.totalCents;
    if (qty === currentQty && total === currentTotal) return;
    render(qty, {
      animate: Boolean(animate) && qty > currentQty,
      total,
    });
  };

  const widget = document.querySelector('cart-amount');
  const parent = widget?.parentElement;
  if (parent && parent.dataset.mixObserved !== 'true') {
    parent.dataset.mixObserved = 'true';
    new MutationObserver(() => {
      syncFromCartAmount(true);
    }).observe(parent, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-mix-qty', 'data-cart-total-money', 'data-cart-total'],
    });
  }

  cartBtn?.addEventListener('click', () => {
    document.querySelector('#header [data-element="cart-btn"]')?.click();
  });

  bar.querySelector('[data-mix-builder-action="open_builder"]')?.addEventListener('click', () => {
    publish('mix_builder_start', {
      eligible_qty: currentQty,
      target,
      percent: Number(percent),
    });
  });

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, window.location.origin);
    if (url.pathname !== '/checkout') return;
    publish('mix_builder_checkout_start', {
      eligible_qty: currentQty,
      target,
      percent: Number(percent),
    });
  });

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.closest('[data-module="product-form"]')) return;
      window.setTimeout(() => syncFromCartAmount(true), 350);
      window.setTimeout(() => syncFromCartAmount(true), 900);
    },
    true
  );

  render(currentQty);
  publish('mix_builder_impression', {
    eligible_qty: currentQty,
    target,
    percent: Number(percent),
  });
})();
